import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { request } from "../request/request";

const initialState = {
    options: {},
    loadingStatus: {},
    error: {}
}

export const fetchFieldOptions = createAsyncThunk(
    "fieldOptions/fetchFieldOptions",
    async ({ fieldName, url, token }, thunkApi) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            };

            const response = await request(
                url,
                "GET",
                null,
                customHeaders
            );

            return {
                fieldName,
                options: response.data || []
            };
        } catch (error) {
            return thunkApi.rejectWithValue({
                fieldName,
                error: error.status || error.message
            });
        }
    }
);

const fieldOptionsSlice = createSlice({
    name: "fieldOptions",
    initialState,
    reducers: {
        resetFieldOptions: (state, action) => {
            const fieldName = action.payload;
            delete state.options[fieldName];
            delete state.loadingStatus[fieldName];
            delete state.error[fieldName];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchFieldOptions.pending, (state, action) => {
                const { fieldName } = action.meta.arg;
                state.loadingStatus[fieldName] = "loading";
                state.error[fieldName] = null;
            })
            .addCase(fetchFieldOptions.fulfilled, (state, action) => {
                const { fieldName, options } = action.payload;
                state.options[fieldName] = options;
                state.loadingStatus[fieldName] = "idle";
                state.error[fieldName] = null;
            })
            .addCase(fetchFieldOptions.rejected, (state, action) => {
                const { fieldName } = action.payload || action.meta.arg;
                state.options[fieldName] = [];
                state.loadingStatus[fieldName] = "error";
                state.error[fieldName] = action.payload?.error || "Ошибка загрузки";
            })
    }
})

export const { resetFieldOptions } = fieldOptionsSlice.actions;

export default fieldOptionsSlice.reducer;
